
import { FormControl, Select, MenuItem, Box, InputBase } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const SearchableDropdown = ({
  value,
  onChange,
  options,
  placeholder = "Select...",
  disabled = false,
}) => {
  const [search, setSearch] = useState("");

  const filteredOptions = options.filter((opt) =>
    opt.toLowerCase().includes(search.toLowerCase())
  );
const {t}=useTranslation()
  return (
    <FormControl fullWidth size="small">
      <Select
        value={value}
           renderValue={() => (value ? value : t(placeholder))} // translated
        onChange={(e) => {
          onChange(e.target.value);
          setSearch("");
        }}
      
        displayEmpty
        disabled={disabled}
        MenuProps={{
          disableAutoFocusItem: true,   // IMPORTANT FIX
          PaperProps: {
            style: { maxHeight: 300 },
          },
        }}
      >
        {/* Search Input */}
       <MenuItem
  disableRipple
  disableTouchRipple
  onKeyDown={(e) => e.stopPropagation()}
  sx={{
    backgroundColor: "transparent !important",
    "&:hover": { backgroundColor: "transparent !important" },
    "&.Mui-focusVisible": { backgroundColor: "transparent !important" },
    p: 1,
  }}
>
  <InputBase
    autoFocus
  placeholder={t("search")} 
    value={search}
    onClick={(e) => e.stopPropagation()}
    onChange={(e) => setSearch(e.target.value)}
    sx={{
      width: "100%",
      backgroundColor: "#fff !important",   // force white background
      border: "1px solid #ccc",
      borderRadius: "6px",
      px: 1,
      py: 0.7,
      fontSize: "14px",
      fontFamily: "Poppins, sans-serif",
      transition: "all 0.2s ease",

      "&:focus": {
        borderColor: "#1976d2",
        boxShadow: "0 0 0 2px rgba(25,118,210,0.2)",
        backgroundColor: "#fff !important",  // stays white on focus
      },
    }}
  />
</MenuItem>

        {/* Filtered Items */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((item) => (
            <MenuItem
              key={item}
              value={item}
              sx={{
                fontSize: "14px",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {item}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled sx={{fontSize:"14px"}}> {t("noResultsFound")}  </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SearchableDropdown;
